const base =
    import.meta.env.VITE_DEPLOYMENT === "DEV"
        ? "https://apim-dev-mvtecenter-w2.azure-api.net"
        : "https://apim-mvt-mvtecenter-w2.azure-api.net";
export const baseUri = `${base}/api/MVTCustomerServiceAPI`;
export const baseUriCoreApi = `${base}/api/coreapi`;
export const baseUriSF = `${base}/api/ServiceFailuresAPI`;
export const baseUriSFV2 = `${base}/api/mvte/sf`;
export const baseUriTI = `${base}/api/PlatSciTabletMgt`;
export const baseEngaugeAssistant = `${base}/api/engaugeassistant`;
export const baseBlogStorage = `${base}/api/Storage`;
export const baseUrlUsps = `${base}/usps`;
export const baseMvteApi = `${base}/api/mvte`;
export const basePartnerManagement = `${base}/api/LoadTCore`;
export const baseRateCalculator = `${base}/api/mvte`;
//export const baseHRAdminApi = `http://localhost:7135/api`;
export const baseHRAdminApi = `${base}/hradmin`;
export const baseITAdminApi = `${base}/itadmin`;

export const roles = [
    "",
    "Manager",
    "Director",
    "Customer Engagement Manager",
    "Operations Manager",
    "Procurement",
    "Account Manager",
    "Account Rep",
    "Order Entry",
    "Weekend",
    "Night ECT",
    "Trainer",
];

export const TabletTerminals = ["El Paso", "Laredo", "Nashville"];

export type SFCategory = {
    Role: string;
    Category: string;
    Type: string;
    EmployeeCodeRequired: boolean;
    CategoryRequired: boolean;
};

export const sfCategories = [
    {
        Role: "Local",
        Category: "Div190",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "Local",
        Category: "Div290",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "Local",
        Category: "Div390",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "Local",
        Category: "Div490",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "Customer",
        Category: "Customer Issue",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: false,
    },
    {
        Role: "DOM",
        Category: "Triangle Freight Team",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "DOM",
        Category: "Triangle Fleet Team",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "DOM",
        Category: "CA-TN Freight Team",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "DOM",
        Category: "CA-TN Fleet Managers",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "DOM",
        Category: "Tx Freight Team",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "DOM",
        Category: "Tx Fleet Managers",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "DOM",
        Category: "Division 380",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "DOM",
        Category: "Dedicated 690",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA1 - Account Manager",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA1 - Order Entry Clerk ",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA1 - ECT",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA1 - Weekend CSR",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA2 - Account Manager ",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA2 - Order Entry Clerk ",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA2 - ECT ",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA2 - Weekend CSR ",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA3 - Account Manager",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA3 - Order Entry Clerk",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA3 - ECT",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NA3 - Weekend CSR",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB1 - Account Manager",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB1 - Order Entry Clerk",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB1 - ECT",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB1 - Weekend CSR",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB2 - Account Manager",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB2 - Order Entry Clerk",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB2 - ECT",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB2 - Weekend CSR",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB3 - Account Manager",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB3 - Order Entry Clerk",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB3 - ECT",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "NB3 - Weekend CSR",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "ELP MX CSR",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "CSM",
        Category: "LAREDO MX CSR",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "Equipment",
        Category: "Mechanical Issues",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: false,
    },
    {
        Role: "Other",
        Category: "Border Crossing Issue",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "Other",
        Category: "Weather",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "N/A",
        Category: "No Service Failure",
        Type: "No Service Failure",
        EmployeeCodeRequired: false,
        CategoryRequired: false,
    },
    {
        Role: "MVT Logistics",
        Category: "004 EP",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "MVT Logistics",
        Category: "004 Cinci",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
    {
        Role: "MVT Logistics",
        Category: "004 Aus",
        Type: "Late Arrival",
        EmployeeCodeRequired: false,
        CategoryRequired: true,
    },
];
